module.exports = __webpack_public_path__ + "img/CU.10c90a4a.png";